import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "width", "height"]

import { computed, onMounted, ref } from 'vue'

import { getImage, QuestionnaireView } from '@/models/onboarding'
import type { WelcomePage } from '@/models/onboarding.types'

import Rive from '@/app/components/Rive.vue'
import Layout from '../Layout.vue'
import WelcomeIntro from '../WelcomeIntro.vue'

type AnimationKeyframe = 'intro' | 'showMascot' | 'updateText' | 'showButton'


export default /*@__PURE__*/_defineComponent({
  __name: 'Welcome',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as WelcomePage
})

const animationKeyframes = computed(() => ({
  intro: 0,
  showMascot: 2500,
  updateText: 3000,
  showButton: 5200,
}))

const currentKeyframe = ref<AnimationKeyframe>('intro')

onMounted(() => {
  setTimeout(() => {
    currentKeyframe.value = 'showMascot'
    props.view.showLogo()
  }, animationKeyframes.value.showMascot)

  setTimeout(() => {
    currentKeyframe.value = 'updateText'
  }, animationKeyframes.value.updateText)

  setTimeout(() => {
    currentKeyframe.value = 'showButton'
    props.view.showContinueButton()
  }, animationKeyframes.value.showButton)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: _normalizeClass(["onboarding-welcome", [`onboarding-welcome--${currentKeyframe.value}`]]),
    title: page.value.title,
    subtitle: page.value.subtitle
  }, {
    default: _withCtx(() => [
      _createVNode(WelcomeIntro, {
        title: page.value.introTitle,
        class: "onboarding-welcome__intro"
      }, null, 8, ["title"]),
      (currentKeyframe.value !== 'intro')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(getImage)(page.value.image.src),
            width: page.value.image.width,
            height: page.value.image.height,
            class: "onboarding-welcome__mascot"
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(Rive, {
        class: "onboarding-welcome__rive",
        src: _unref(getImage)('preload.riv')
      }, null, 8, ["src"]), [
        [_vShow, false]
      ])
    ]),
    _: 1
  }, 8, ["class", "title", "subtitle"]))
}
}

})